import { render, staticRenderFns } from "./BatchPicture.vue?vue&type=template&id=0a04da9b&"
import script from "./BatchPicture.vue?vue&type=script&lang=js&"
export * from "./BatchPicture.vue?vue&type=script&lang=js&"
import style0 from "./BatchPicture.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a04da9b')) {
      api.createRecord('0a04da9b', component.options)
    } else {
      api.reload('0a04da9b', component.options)
    }
    module.hot.accept("./BatchPicture.vue?vue&type=template&id=0a04da9b&", function () {
      api.rerender('0a04da9b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/aduanas/batches/views/components/modals/BatchPicture.vue"
export default component.exports